var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoExportTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11612 0H2.5C1.11929 0 0 1.11929 0 2.5V17.5C0 18.8807 1.11929 20 2.5 20H12.5C13.8807 20 15 18.8807 15 17.5V5.88388C15 5.55236 14.8683 5.23442 14.6339 5L10 0.366117C9.76558 0.131696 9.44764 0 9.11612 0ZM9.375 4.375V1.875L13.125 5.625H10.625C9.93464 5.625 9.375 5.06536 9.375 4.375ZM8.125 9.375V14.1161L9.55806 12.6831C9.80214 12.439 10.1979 12.439 10.4419 12.6831C10.686 12.9271 10.686 13.3229 10.4419 13.5669L7.94194 16.0669C7.69786 16.311 7.30214 16.311 7.05806 16.0669L4.55806 13.5669C4.31398 13.3229 4.31398 12.9271 4.55806 12.6831C4.80214 12.439 5.19786 12.439 5.44194 12.6831L6.875 14.1161V9.375C6.875 9.02982 7.15482 8.75 7.5 8.75C7.84518 8.75 8.125 9.02982 8.125 9.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExportTemplate);
export default __webpack_public_path__ + "static/media/ico-export-template.cea585fd1270351da68a555b695a63a8.svg";
export { ForwardRef as ReactComponent };